/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, checkAuth } from '../authContext';
import styles from '../styles/RequireAuth.module.css';

/**
 * Guarda de las rutas privadas.
 *
 * Reemplaza el `useEffect` con checkAuth que estaba repetido en cada página, y
 * al viejo PrivateRoute, escrito para React Router v5 cuando el proyecto usa v6.
 *
 * La diferencia que importa: espera a que el contexto termine de recuperar la
 * sesión. Aquellas comprobaciones eran síncronas y mandaban al login antes de
 * que la renovación alcanzara a responder, así que un access token vencido
 * costaba un código nuevo aunque el refresh token siguiera siendo válido.
 */
export default function RequireAuth({ children }) {
    const { tokens, bootstrapping, refreshing, refreshTokens } = useAuth();

    // El arranque cubre abrir la app con el token vencido. Este es el otro caso:
    // la pestaña lleva rato abierta, el temporizador no llegó a dispararse y el
    // token caducó mientras tanto.
    //
    // Se calcula durante el render, no en un efecto: los efectos corren después,
    // y para entonces la redirección al login ya se decidió. Ese fue justamente
    // el primer intento de arreglarlo, y seguía echando al agente.
    const recoverable = !!tokens?.RefreshToken && !checkAuth(tokens);

    useEffect(() => {
        if (bootstrapping || refreshing) return;
        if (recoverable) refreshTokens();
    }, [recoverable, bootstrapping, refreshing, refreshTokens]);

    if (bootstrapping || refreshing || recoverable) {
        return (
            <div className={styles.container}>
                <img
                    src="images/cs-loginSoyMomoImage.svg"
                    width={80}
                    height={80}
                    alt=""
                    className={styles.logo}
                />
                <p className={styles.text}>Recuperando tu sesión...</p>
            </div>
        );
    }

    if (!tokens || !checkAuth(tokens)) {
        return <Navigate to="/login" replace />;
    }

    return children;
}
